module.exports = __webpack_public_path__ + "img/attack_health.0531120b.png";